<!--项目辅导-->
<template>
  <div class="coach-container">
    <header-index/>
    <div class="coach-content">
      <div class="coach-top">
        <p class="coach-title">{{ childNode.name }}企业政策服务平台</p>
        <div class="coach-list">
          <span>政府培育</span><span class="interval-span">·</span><span>政府对接</span><span
            class="interval-span">·</span><span>信息直达</span>
        </div>
      </div>
      <div class="coach-menu">
        <div class="float-layer">
          <el-row :gutter="14">
            <el-col :span="12" style="padding-left: 0px;padding-right: 0px;">
              <p class="layer-title">
                <span>惠企政策申报排行</span>
                <el-link type="primary" :underline="false" @click="declareMoreRank">查看更多<i class="el-icon-arrow-right"/>
                </el-link>
              </p>
              <div class="float-layer-content">
                <div class="rank-list">
                  <div class="left-rank">
                    <span>排名</span>
                    <span style="padding-left: 20px;">政策项目名</span>
                  </div>
                  <div class="rank-count">
                    <span>获批企业数</span>
                  </div>
                </div>
                <div v-for="(list,index) of declareRank" class="rank-list" @click="declareRankDetails(list)">
                  <div class="left-rank">
                    <i :class="'rank'+Number(index+1)"/>
                    <div class="rank-span">{{ list.name }}</div>
                  </div>
                  <div class="rank-count">
                    <div class="rank-span">{{ list.num }}家</div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 30px;padding-right: 30px;">
              <p class="layer-title">
                <span>企业获得补贴排行</span>
                <el-link type="primary" :underline="false" @click="subsidyMoreRank">查看更多<i class="el-icon-arrow-right"/>
                </el-link>
              </p>
              <div class="float-layer-content">
                <div class="rank-list">
                  <div class="left-rank">
                    <span>排名</span>
                    <span style="padding-left: 20px;">企业名称</span>
                  </div>
                  <div class="rank-count">
                    <span>补贴政策</span>
                  </div>
                </div>
                <div v-for="(list,index) of subsidyRank" class="rank-list">
                  <div class="left-rank">
                    <i :class="'rank'+Number(index+1)"/>
                    <div class="rank-span">{{ list.name }}</div>
                  </div>
                  <div class="rank-count">
                    <el-link type="primary" :underline="false" @click="subsidyRankDetails(list)">详情</el-link>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="coach-list-info">
          <p class="coach-title" ref="tit">最新政策</p>
          <div class="coach-search">
            <el-dropdown @command="changeDeptName" trigger="click">
            <span class="el-dropdown-link">
              {{ deptName ? deptName : '部门' }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="''">全部</el-dropdown-item>
                <el-dropdown-item v-for="options in policyDepartmentList" :command="options.dictValue"
                                  :style="options.dictValue==deptName ? 'background: #ECEFFE;color: #1637FF;' : ''">
                  {{ options.dictLabel }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="changeDataRange" trigger="click">
            <span class="el-dropdown-link">
              {{ timeName ? timeName : '时间' }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="''">全部</el-dropdown-item>
                <el-dropdown-item v-for="options in dataRangeItem" :command="options.dictValue"
                                  :style="options.dictValue==time ? 'background: #ECEFFE;color: #1637FF;' : ''">
                  {{ options.dictLabel }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="changeStatus" trigger="click">
            <span class="el-dropdown-link">
              {{ status ? statusName : '状态' }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="options in statusItem" :command="options.value"
                                  :style="options.value==status ? 'background: #ECEFFE;color: #1637FF;' : ''">
                  {{ options.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="coach-info" v-if="subsidyPolicyList.length>0">
            <div class="coach-list" v-for="item of subsidyPolicyList" @click="declareRankDetails(item)">
              <p class="coach-small-title">{{ item.title }}</p>
              <i :class="item.policyStatus=='已截止' ? 'status-stop' : 'status-afoot'">{{ item.policyStatus }}</i>
              <span class="gray-span">组织部门：</span><span class="block-span">{{ item.department }}</span>
              <span class="gray-span">申报时间：</span><span class="block-span">{{ item.timeFormat }}</span>
            </div>
            <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"
                  :limit="tablePage.pageSize"
                  style="padding: 20px 25px 15px 10px;"/>
          </div>
          <div class="coach-info" v-else>
            <el-empty description="暂无内容"/>
          </div>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <!--惠企政策申报排行-->
    <vxe-modal v-model="dialog1" width="600" :showHeader="false" transfer mask-closable show-close>
      <template #default>
        <div class="dialog">
          <vxe-button type="text" icon="fa vxe-icon--close" class="close-btn" title="关闭" @click="dialog1=false"/>
          <div class="dialog-top">
            <div class="small-tips">惠企政策申报</div>
            <div class="bigger-tips">排行榜</div>
          </div>
          <div class="rank-list">
            <el-row class="row-header">
              <el-col :span="2">排名</el-col>
              <el-col :span="17">政策项目名</el-col>
              <el-col :span="5" style="text-align: right;padding-right: 30px;">获批企业数</el-col>
            </el-row>
            <div class="row-content">
              <el-row class="row-list" v-for="(rank,index) of declarationRank">
                <div @click="declareRankDetails(rank)">
                  <el-col :span="2">
                    <div :class="'rank'+Number(index+1)" v-if="index<3"></div>
                    <div class="rank" v-else>{{ Number(index + 1) }}</div>
                  </el-col>
                  <el-col :span="17"><span class="rank-span">{{ rank.name }}</span></el-col>
                  <el-col :span="5" style="padding-right: 30px;"><span class="rank-count">{{ rank.num }}家</span>
                  </el-col>
                </div>
              </el-row>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
    <!--企业获得补贴排行-->
    <vxe-modal v-model="dialog2" width="600" :showHeader="false" transfer mask-closable show-close>
      <template #default>
        <div class="dialog">
          <vxe-button type="text" icon="fa vxe-icon--close" class="close-btn" title="关闭"
                      @click="dialog2=false"></vxe-button>
          <div class="dialog-top">
            <div class="small-tips">企业获得补贴</div>
            <div class="bigger-tips">排行榜</div>
          </div>
          <div class="rank-list">
            <el-row class="row-header">
              <el-col :span="2">排名</el-col>
              <el-col :span="17">企业名称</el-col>
              <el-col :span="5" style="text-align: right;padding-right: 30px;">补贴政策</el-col>
            </el-row>
            <div class="row-content">
              <el-row class="row-list" v-for="(sub,index) of subsidy_rank">
                <el-col :span="2">
                  <div :class="'rank'+Number(index+1)" v-if="index<3"></div>
                  <div class="rank" v-else>{{ Number(index + 1) }}</div>
                </el-col>
                <el-col :span="17"><span class="rank-span">{{ sub.name }}</span></el-col>
                <el-col :span="5" style="padding-right: 30px;">
                  <span class="rank-count">
                    <el-link type="primary" :underline="false" @click="subsidyRankDetails(sub)">详情</el-link>
                  </span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
import Vue from 'vue';
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import page from "@/components/page/pages";
import {
  businessesSubsidiesLeaderboard,
  policyDeclarationLeaderboard,
  newFundingSubsidyPolicyZhongDianZhengCeList,
  newPolicyDepartmentList,
  policyForTime
} from '@/api/projectCoach'
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';

Vue.use(VXETable)
export default {
  name: "index",
  components: {Hang, Home_footer, HeaderIndex, page},
  data() {
    return {
      cid: 0,
      cityList: {},
      childNode: {},
      /*企业获得补贴排行*/
      subsidyRank: [],
      /*惠企政策申报排行*/
      declareRank: [],
      /*部门*/
      deptName: '',
      /*时间*/
      time: '',
      /*状态*/
      status: '',
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      subsidyPolicyList: [],
      policyDepartmentList: [],
      dataRangeItem: [],
      statusItem: [
        {label: '全部', value: ''},
        {label: '已截止', value: '2'},
        {label: '申报中', value: '1'},
      ],
      dept: '',
      timeName: '',
      statusName: '状态',
      dialog1: false,
      dialog2: false,
      declarationRank: [],
      subsidy_rank: [],
    }
  },
  watch: {
    deptName(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getPolicyInfoList();
      }
    },
    time(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getPolicyInfoList();
      }
    },
    status(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getPolicyInfoList();
      }
    }
  },
  methods: {
    /*企业获得补贴排行榜列表*/
    getBusinessesSubsidiesLeaderboard() {
      businessesSubsidiesLeaderboard({
        cityCode: this.cityList.id,
        page: 1,
        pageLimit: 3,
        cid: this.cid,
        uid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.subsidyRank = res.content.rows;
        }
      })
    },
    /*惠企政策申报排行榜列表*/
    getPolicyDeclarationLeaderboard() {
      policyDeclarationLeaderboard({
        cityCode: this.cityList.id,
        page: 1,
        pageLimit: 3,
        cid: this.cid,
        uid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.declareRank = res.content.rows;
        }
      })
    },
    /*重点项目申报政策列表 / 资金申报政策列表*/
    getPolicyInfoList() {
      newFundingSubsidyPolicyZhongDianZhengCeList({
        code: this.cityList.id,
        deptName: this.deptName,
        pageNum: this.tablePage.currentPage - 1,
        status: this.status,
        time: this.time,
        cid: this.cid,
        uid: this.cid,
        request: 'form'
      }).then(res => {
        if (res.code = 200) {
          window.scrollTo(0, this.$refs.tit.offsetTop - 50);
          this.subsidyPolicyList = res.content.list;
          this.tablePage.total = res.content.totalNum;
        }
      })
    },
    /*获取惠企政策辅导部门*/
    getHewPolicyDepartmentList() {
      newPolicyDepartmentList({code: this.cityList.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.policyDepartmentList = res.content.list;
        }
      })
    },
    /*获取申报时间分组*/
    getDataRangeItem() {
      policyForTime().then(res => {
        if (res.code == 200) {
          this.dataRangeItem = res.content.list;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getPolicyInfoList();
    },
    /*监听部门修改*/
    changeDeptName(command) {
      for (let option of this.policyDepartmentList) {
        if (command == '') {
          this.deptName = '';
        } else if (option.dictValue == command) {
          this.deptName = option.dictValue;
          this.dept = option.dictLabel;
        }
      }
    },
    /*监听时间修改*/
    changeDataRange(command) {
      for (let option of this.dataRangeItem) {
        if (command == '') {
          this.time = '';
        } else if (option.dictValue == command) {
          this.time = option.dictValue;
          this.timeName = option.dictLabel;
        }
      }
    },
    /*监听状态变更*/
    changeStatus(command) {
      if (command == '') {
        this.statusName = '';
        this.status = '';
      } else {
        for (let option of this.statusItem) {
          if (option.value == command) {
            this.status = option.value;
            if (option.label != '全部')
              this.statusName = option.label;
          }
        }
      }
    },
    /*惠企政策申报排行-查看更多*/
    declareMoreRank() {
      policyDeclarationLeaderboard({
        cityCode: this.cityList.id,
        page: 1,
        pageLimit: 100,
        cid: this.cid,
        uid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.declarationRank = res.content.rows;
          this.dialog1 = true;
        }
      })
    },
    /*企业获得补贴排行-查看更多*/
    subsidyMoreRank() {
      businessesSubsidiesLeaderboard({
        cityCode: this.cityList.id,
        page: 1,
        pageLimit: 100,
        cid: this.cid,
        uid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.subsidy_rank = res.content.rows;
          this.dialog2 = true;
        }
      })
    },
    /*惠企政策申报详情*/
    declareRankDetails(row){
      let routeData = this.$router.resolve({
        name: "declareRankDetails",
        path: '/projectCoach/declareRankDetails',
        query: {
          policyId:row.policyId || row.id,
          cid:this.cid
        },
      });
      window.open(routeData.href, '_blank')
    },
    /*企业获得补贴详情*/
    subsidyRankDetails(row){
      let routeData = this.$router.resolve({
        name: "subsidyRankDetails",
        path: '/projectCoach/subsidyRankDetails',
        query: {
          id:row.cid,
          uid:this.cid,
          name:row.name
        },
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getBusinessesSubsidiesLeaderboard();
    this.getPolicyDeclarationLeaderboard();
    this.getHewPolicyDepartmentList();
    this.getDataRangeItem();
    this.getPolicyInfoList();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.coach-container >>> .coach-content .float-layer .layer-title .el-link.el-link--primary {
  color: #1637FF;
  font-size: 12px;
  font-family: 'SourceHanSansCN';
}

.coach-container >>> .coach-content .float-layer .float-layer-content .el-link.el-link--primary {
  color: #1637FF;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
}

.coach-container >>> .coach-content .coach-list-info .coach-search .el-dropdown {
  color: #333333;
  font-size: 14px;
  margin-right: 30px;
  padding: 20px 0px;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.coach-container {
  background: #FFFFFF;

  .coach-content {
    .coach-top {
      background: url("~@/assets/img/cloud/projectCoach.png") no-repeat;
      height: 330px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;

      .coach-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 60px 0px 20px;
        font-weight: bold;
        text-shadow: 0px 4px 0px #13485F;
      }

      .coach-list {
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 51%, rgba(255, 255, 255, 0) 100%);
        width: 480px;
        padding: 16px;
        text-align: center;
        display: inline-block;

        span {
          font-size: 18px;
          font-family: 'SourceHanSansCN';
          color: #333333;
          line-height: 18px;
          cursor: pointer;
        }

        .interval-span {
          padding: 0px 20px;
        }
      }
    }
    .coach-menu{
      padding: 0px 18%;
      min-width: 76rem;
      background: #fff;
      .float-layer {
        margin: -60px 0% 0px;
        box-shadow: 3px 5px 8px 4px rgb(196 196 196 / 50%);
        background: white;
        padding: 20px;
        position: absolute;
        width: 74rem;

        .layer-title {
          font-size: 16px;
          font-family: "SourceHanSansCN";
          color: #333333;
          margin-block-start: 0px;
          margin-block-end: 0px;
          display: flex;
          justify-content: space-between;
          align-items: end;
          span{
            cursor: pointer;
          }
          .el-icon-arrow-right {
            font-size: 12px;
            color: #1637FF;
            font-weight: bold;
          }
        }

        .float-layer-content {
          background: #F2F3FB;
          padding: 20px;
          margin-top: 10px;

          .rank-list {
            padding: 0px 0px 10px 0px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left-rank {
              display: flex;
              justify-content: left;
              cursor: pointer;
              .rank1 {
                background: url("~@/assets/img/cloud/ranking1.png") no-repeat;
                height: 23px;
                width: 20px;
                background-size: 100% 100%;
                position: absolute;
              }

              .rank2 {
                background: url("~@/assets/img/cloud/ranking2.png") no-repeat;
                height: 23px;
                width: 20px;
                background-size: 100% 100%;
                position: absolute;
              }

              .rank3 {
                background: url("~@/assets/img/cloud/ranking3.png") no-repeat;
                height: 23px;
                width: 20px;
                background-size: 100% 100%;
                position: absolute;
              }

              .rank-span {
                padding-left: 45px;
                color: #333333;
                font-size: 14px;
                overflow: hidden;
                display: -webkit-box;
                width: 250px;
                line-height: 25px;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }

              span {
                font-size: 12px;
                font-family: 'SourceHanSansCN';
                color: #666666;
                line-height: 24px;
              }
            }

            .rank-count {
              float: right;
              color: #333333;
              font-size: 14px;
              cursor: pointer;
              span {
                font-size: 12px;
                font-family: 'SourceHanSansCN';
                color: #666666;
                line-height: 24px;
              }
            }
          }
        }
      }

      .coach-list-info {
        background: #FFFFFF;
        padding: 30px 0px;
        padding-top: 205px;
        .coach-title {
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #333333;
          margin-block-end: 0px;
          margin-block-start: 0px;
        }

        .coach-info {
          background: #FFFFFF;

          .coach-list {
            padding: 20px 0px;
            border-bottom: 1px solid #F2F3FB;

            .coach-small-title {
              font-size: 18px;
              font-family: 'SourceHanSansCN';
              color: #333333;
              margin-block-end: 0px;
              margin-block-start: 0px;
              padding-bottom: 10px;
            }

            .status-stop {
              font-style: normal;
              font-size: 12px;
              padding: 5px 10px;
              font-family: 'SourceHanSansCN';
              border-radius: 6px;
              color: #FE273B;
              background: #FFD2D4;
            }

            .status-afoot {
              background: #ECEFFE;
              color: #1637FF;
              font-style: normal;
              font-size: 12px;
              padding: 5px 10px;
            }

            .gray-span {
              color: #999999;
              font-size: 14px;
              font-family: 'SourceHanSansCN';
              padding-left: 20px;
            }

            .block-span {
              font-size: 14px;
              color: #333333;
              font-family: 'SourceHanSansCN';
              padding-right: 30px;
            }
          }
        }
      }

      .coach-search {
        border-bottom: 1px solid #F2F3FB;
      }
    }
  }
}

.vxe-modal--box {
  .dialog-top {
    background: url("~@/assets/img/cloud/rankList.png") no-repeat;
    height: 70px;
    line-height: initial;
    background-size: 100%;
    padding: 30px 70px;

    .small-tips {
      color: #FFFFFF;
      font-size: 18px;
    }

    .bigger-tips {
      color: #FFFFFF;
      font-size: 32px;
    }
  }

  .close-btn {
    top: 0px;
    z-index: 999999999;
    position: absolute;
    right: 0px;
  }

  .rank-list {
    padding: 20px 10px 20px 20px;

    .row-header {
      color: #999999;
      padding-bottom: 20px;
    }

    .row-content {
      overflow: auto;
      height: 420px;

      .row-list {
        padding-bottom: 20px;

        .rank {
          height: 23px;
          width: 20px;
          text-align: center;
          color: #6A747E;
          font-size: 14px;
          font-style: normal;
        }

        .rank1 {
          background: url("~@/assets/img/cloud/ranking1.png") no-repeat;
          height: 23px;
          width: 20px;
          background-size: 100% 100%;
        }

        .rank2 {
          background: url("~@/assets/img/cloud/ranking2.png") no-repeat;
          height: 23px;
          width: 20px;
          background-size: 100% 100%;
        }

        .rank3 {
          background: url("~@/assets/img/cloud/ranking3.png") no-repeat;
          height: 23px;
          width: 20px;
          background-size: 100% 100%;
        }

        .rank-span {
          color: #333333;
          font-size: 14px;
        }

        .rank-count {
          float: right;
          color: #333333;
          font-size: 14px;
          .el-link{
            color: #1637FF;
            font-size: 12px;
            font-family: 'SourceHanSansCN';
          }
        }
      }
    }

    .row-content::-webkit-scrollbar {
      width: 4px;
    }

    .row-content::-webkit-scrollbar-thumb {
      height: 8px;
      border-radius: 8px;
      background-color: #DDDDDD;
    }
  }
}
</style>
<style>
.vxe-modal--wrapper .vxe-modal--box {
  border: none;
}

.vxe-modal--wrapper .vxe-modal--content {
  padding: 0px;
  background: white;
}

.el-dialog__header {
  padding: 15px 15px 15px !important;
  background: #F1F1F1;
}
</style>